import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ClsEncrDec } from 'app/modules/Renewal-Module-Dashboard/Renewal-Module-Dashboard.model';
import CryptoJS from 'crypto-js';
import { environment } from 'environment/environment';
import { catchError, Observable, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EncryptdecryptService {

  private tokenFromUI: string = environment.EncryptKey;
  //private key = CryptoJS.enc.Utf8.parse(environment.EncryptKey);
  private _authenticated: boolean = false;
  private apiUrl = environment.baseUrl;
  private apiUserId = environment.createdby;
  encrypted: any = "";
  decrypted: string;
  ids:string = "";
  // request: string;
  // responce: string;
  clsClsEncrDec: ClsEncrDec = new ClsEncrDec();

  private iv = CryptoJS.enc.Utf8.parse(environment.EncryptIV);
  constructor(private _httpClient: HttpClient) { }
  // Methods for the encrypt and decrypt Using AES
  
  encryptUsingAES256(text) : any {
    let _key = CryptoJS.enc.Utf8.parse(this.tokenFromUI);
    let _iv = CryptoJS.enc.Utf8.parse(this.tokenFromUI);
    let encrypted = CryptoJS.AES.encrypt(
      JSON.stringify(text), _key, {
        keySize: 16,
        iv: _iv,
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
      });
    this.encrypted = encrypted.toString();

    return this.encrypted.toString();
  }

  decryptUsingAES256(text) : any  {
    let _key = CryptoJS.enc.Utf8.parse(this.tokenFromUI);
    let _iv = CryptoJS.enc.Utf8.parse(this.tokenFromUI);

    this.decrypted = CryptoJS.AES.decrypt(
      text, _key, {
        keySize: 16,
        iv: _iv,
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
      }).toString(CryptoJS.enc.Utf8);

      return this.decrypted.toString();
  }

  // getEncryptid(id: any): Observable<any> {
  //   //debugger;
  //   this.ids = id;
  //   //console.log("test log : getEncryptid API Call", id);
  //   return this._httpClient.get<any>(this.apiUrl + 'EncryptDecrypt/Encrypt/' + this.ids);
  // }
  getEncryptid(id: any): Observable<any> {
    //debugger;
    this.ids = id;
    //console.log("test log : getEncryptid API Call", id);
   // return this._httpClient.get<any>(this.apiUrl + 'EncryptDecrypt/Encrypt/' + this.ids);
   const safeId = encodeURIComponent(String(id).trim()).replace(/%2B/g, '+');
    const url = `${this.apiUrl}EncryptDecrypt/Encrypt/${safeId}`;
 
    console.log("Calling Encrypt API URL:", url); // Debug log
    return this._httpClient.get<any>(url);
  }

    getEncryptidforrenewal(id: any): Observable<any> {
      const encodedId = encodeURIComponent(id);
      const body = { plainText: encodedId };
      const url = `${this.apiUrl}EncryptDecrypt/EncryptForrenewal`;
      return this._httpClient.post<any>(url, body);
    }

    handleError(error: HttpErrorResponse) {
      return throwError(error);
    }

  getDecryptid(id : any): Observable<any> {
    //debugger;
    return this._httpClient.get<any>(this.apiUrl + 'EncryptDecrypt/Decrypt/' + id);
  }

  
  getDecryptidforrenewal(id : any): Observable<any> {
      const body = { plainText: id };
      const url = `${this.apiUrl}EncryptDecrypt/DecryptForrenewal`;
      return this._httpClient.post<any>(url, body);
  }

  getesigndecrptid(id :any):Observable<any> {
    //debugger;
    return this._httpClient.get<any>(this.apiUrl + 'Esign/Decrypt/' + id);
    
  }
 
}
